export const FLOW_NAMES = {
    E2E: 'e2e',
    BPCE: 'billma'
}

export const FLOW_STATES = {
    NEW: 'NEW',
    CLAIM_DETAILS: 'CLAIM_DETAILS',
    PROCESSED: 'PROCESSED',
    PROCESSED_OK: 'PROCESSED_OK',
    PROCESSED_KO: 'PROCESSED_KO',
    PROCESSED_ERROR: 'PROCESSED_ERROR',
    PROCESSED_ERROR_RDF: 'PROCESSED_ERROR_RDF',
    PROCESSED_ERROR_BILLMA: 'PROCESSED_ERROR_BILLMA',
    PROCESSED_KO_BILLMA: 'PROCESSED_KO_BILLMA',
    PROCESSED_ERROR_REN: 'PROCESSED_ERROR_REN',
    PROCESSED_KO_REN: 'PROCESSED_KO_REN',
    DAMAGES: 'DAMAGES',
    GAG_DETAILS: 'GAG_DETAILS',
    BILLMA: 'BILLMA',
    REN_DETAILS: 'REN_DETAILS',
    REN_DETAILS_RDF: 'REN_DETAILS_RDF',
    SMART: 'SMART',
    COMPENSATION_TYPE: 'COMPENSATION_TYPE',
    COMPENSATION_MOBILIER: 'COMPENSATION_MOBILIER',
    COMPENSATION_MOBILIER_REN: 'COMPENSATION_MOBILIER_REN',
    COMPENSATION_MOBILIER_BILLMA: 'COMPENSATION_MOBILIER_BILLMA',
    COMPENSATION_FRAIS: 'COMPENSATION_FRAIS',
    COMPENSATION_FRAIS_REN: 'COMPENSATION_FRAIS_REN',
    COMPENSATION_FRAIS_BILLMA: 'COMPENSATION_FRAIS_BILLMA',
    COMPENSATION_MOBILIER_PROCESSED_OK: 'COMPENSATION_MOBILIER_PROCESSED_OK',
    COMPENSATION_MOBILIER_PROCESSED_KO: 'COMPENSATION_MOBILIER_PROCESSED_KO',
    WAITING_ROOM: 'WAITING_ROOM',
    NEW_CONTACT: 'NEW_CONTACT',
    MANUAL_REVIEW: 'MANUAL_REVIEW',
    GAG_RESUME: 'GAG_RESUME',
    REN_RESUME: 'REN_RESUME',
    BILLMA_RESUME: 'BILLMA_RESUME',
    MANUAL_REVIEW_RDF: 'MANUAL_REVIEW_RDF',
    RDF_REN: 'RDF_REN',
    CALLBACK_REQUEST: 'CALLBACK_REQUEST',
    PROCESSED_KO_RDF: 'PROCESSED_KO_RDF'
}

export const FLOW_TRANSITIONS = {
    SHOW_DETAILS: 'SHOW_DETAILS',
    ADD_DAMAGES: 'ADD_DAMAGES',
    SHOW_COMPENSATION_TYPE: 'SHOW_COMPENSATION_TYPE',
    SHOW_MOBILIER: 'SHOW_MOBILIER',
    SHOW_FRAIS: 'SHOW_FRAIS',
    SHOW_GAG_RESUME: 'SHOW_GAG_RESUME',
    SHOW_REN_RESUME: 'SHOW_REN_RESUME',
    SHOW_BILLMA: 'SHOW_BILLMA',
    // FINISHED: 'FINISHED',
    FINISHED_OK: 'FINISHED_OK',
    FINISHED_KO: 'FINISHED_KO',
    FINISHED_ERROR: 'FINISHED_ERROR',
    MOBILIER_FINISHED_OK: 'MOBILIER_FINISHED_OK',
    MOBILIER_FINISHED_KO: 'MOBILIER_FINISHED_KO',
    CALLBACK_REQUEST: 'CALLBACK_REQUEST',
    SHOW_RESUME: 'SHOW_RESUME',
    FINISHED_OK_RDF: 'FINISHED_OK_RDF',
    FINISHED_KO_RDF: 'FINISHED_KO_RDF',
    FINISHED_ERROR_RDF: 'FINISHED_ERROR_RDF'
}